import posthog from 'app/utils/posthog'

export default {
  install(Vue, options) {
    Vue.config.globalProperties.$posthog = posthog
  }
}
